import styled from "styled-components";
import ModalContent from "./ModalContent";

const DialogContent = styled(ModalContent)`
  width: 500px;
  margin: 1.5rem;
`;

export default DialogContent;
